// extracted by mini-css-extract-plugin
export default {"wrapper":"NoticeAttachmentList_wrapper__mZCal","deleteButton":"NoticeAttachmentList_deleteButton__jQ6Ek"};